module.exports = __webpack_public_path__ + "images/home/index/values-stage-screenshot-ceaec599bf5c9a8bfd6d479e910232f2.png";